

let mutations = {
    issues(state, issue) {
        state.issue = []       
        state.issue = issue   
    },  
    
    setUser(state, user) {
        state.user = user;
    },
}
export default mutations